
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/academy/learn-ethereum",
      function () {
        return require("private-next-pages/academy/learn-ethereum/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/academy/learn-ethereum"])
      });
    }
  